import {
  urls
} from './urls'

import axios from '@/api/axios'

let isProxyApi = process.env.NODE_ENV == 'development'
/**
 * 把json参数对象转换成url中的params拼接参数字符，并返回
 * @param {*json参数对象} data
 */
export function getUrlParamByData(data) {
  let uriParams = ''
  for (var i in data) {
    uriParams += uriParams ? '&' : '?'
    const param = `${i}=${encodeURIComponent(data[i])}`
    uriParams += param
  }
  return uriParams
}

/**
 * 如果是自定义的url属性名则返回对应的属性值，否则返回原url
 * @param {*url或urlName} url
 */
function getUrl(url) {
  if (!url || url.indexOf('/') !== -1) {
    // 是url时返回
    return url
  } else if (urls[url]) {
    // 根据url名称返回url值
    return urls[url]
  } else {
    return url
  }
}

/**
 * 统一的连接服务器接口
 * @param {*string} url url或自定义的url属性名 (默认值'')
 * @param {*string} type request类型 (默认值get)
 * @param {*json} params json参数 (默认值{})
 * @param {*string} subUrl 要拼接到url后面的资源文件名 (默认值'')
 */
export function axiosServer({
  url = '',
  type = 'get',
  params = {},
  subUrl = ''
}) {
  url = getUrl(url) // url转换
  url += subUrl // 拼接子url 我给你看一个装
  url = isProxyApi ? replaceProxyUrl(url) : url // 增加代理字符
  const config = {
    method: type,
    url: url,
    data: params
  }
  if (type === 'get') {
    config.params = params
  }
  return axios(config)
}

/**
 * 统一的连接服务器接口
 * @param {*string} url url或自定义的url属性名 (默认值'')
 * @param {*string} type request类型 (默认值post)
 * @param {*json} params json参数 (默认值{})
 * @param {*string} subUrl 要拼接到url后面的资源文件名 (默认值'')
 * @returns {*json || string} respBody(json) 正常时返回值，如果respBody无效时返回message(string)
 * @returns {*string} message 错误时返回值
 */
export function axiosApi({
  url = '',
  type = 'post',
  params = {},
  subUrl = ''
}) {
  url = getUrl(url)
  url += subUrl
  url = isProxyApi ? replaceProxyUrl(url) : url
  const config = {
    method: type,
    url: url,
    data: params
  }
  if (type === 'post') {
    config.params = params
  }
  return new Promise(async (resolve, reject) => {
    const {
      data: {
        respHeader,
        respBody
      }
    } = await axios(config)
    if (respHeader) {
      if (respHeader.resultCode === 0) {
        resolve(respBody || respHeader.message)
      } else {
        reject(respHeader.message)
      }
    }
  })
}

// 开发环境使用代理服务器时增加代理配置字符/weApp
export function replaceProxyUrl(url) {
  if (process.env.NODE_ENV === 'production') {
    return url
  } else {
    return "proxyApi" + url
  }
}